import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

export const MainImg = styled.img`
  display: none;

  @media (min-width: ${breakpoints.sm}) {
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    cursor: zoom-in;
    flex-grow: 0;
    transition: opacity 0.5s;
  }
`;
